import { ICustomer } from '../interfaces/ICustomer';

import { CURRENT_ORDER_LOCAL_STORAGE_KEY } from '../constants';
import { ICartItem } from '../interfaces/ICartItem';
import { IDeliveryType } from '../interfaces/IDeliveryType';
import { IDeliveryAddress } from '../interfaces/IDeliveryAddress';
import { IFormaPagamentoEmpresa } from '../interfaces/IPaymentMethod';
import { IDiscountCoupon } from '../interfaces/IDiscountCoupon';

export type ICurrentOrder = {
  customer: ICustomer | null;
  deliveryType: IDeliveryType;
  cart: ICartItem[];
  address: IDeliveryAddress | null;
  discountOnTheOutside: number | null;
  observation: string;
  scheduledDelivery: Date | null;
  selectdePaymentMethod: {
    paymentMethod: IFormaPagamentoEmpresa;
    changeMoney: number | null;
  } | null;
  selectedCoupon: IDiscountCoupon | null;
};

export function getCurrentOrder(): ICurrentOrder | undefined {
  const currentOrder = localStorage.getItem(CURRENT_ORDER_LOCAL_STORAGE_KEY);

  if (currentOrder) {
    return JSON.parse(currentOrder);
  }

  return undefined;
}
